// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"9d36e9fe","453":"faeb9172","763":"31462cda","860":"05af52f0"}[chunkId] + ".chunk.js";
};